import type { ApiError } from '@boletra/shared';

export const API_BASE_URL = import.meta.env.VITE_PUBLIC_API_URL ?? 'http://localhost:3000';

export class ApiClientError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: Record<string, unknown>;
  constructor(status: number, error: ApiError) {
    super(error.message);
    this.status = status;
    this.code = error.code;
    this.details = error.details;
  }
}

let accessToken: string | null = null;
export function setAccessToken(token: string | null) {
  accessToken = token;
}

export async function api<T>(
  path: string,
  options: { method?: string; body?: unknown; headers?: Record<string, string> } = {},
): Promise<T> {
  const url = `${API_BASE_URL}${path}`;
  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...options.headers,
  };
  const res = await fetch(url, {
    method: options.method ?? 'GET',
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
    credentials: 'include',
  });
  if (!res.ok) {
    let errBody: { error?: ApiError } = {};
    try {
      errBody = await res.json();
    } catch {
      /* not JSON */
    }
    throw new ApiClientError(
      res.status,
      errBody.error ?? { code: 'generic', message: res.statusText },
    );
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}
